const config = {
    cloudWatchUrlBase: 'https://list.ghrc.earthdata.nasa.gov/',
    sourceIMGUrl: 'https://data.ghrc.earthdata.nasa.gov/ghrcw-public/',
    version: 'v1.1.1'
}

export default config
